import ProductStockTakeHtml from './templates/product-stock-take.html';

export function ProductStockTakeDirective () {
  return {
    controller: 'ProductStockTakeCtrl',
    restrict: 'E',
    templateUrl: ProductStockTakeHtml,
    scope: {
      log: '=',
      product: '='
    }
  }
};